export default {
  labels: 'labels',
}
